import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 bg-neutral-900 border-y border-neutral-800" data-id="element-127">
      <div className="container mx-auto px-4" data-id="element-128">
        <div className="max-w-3xl mx-auto bg-neutral-950 border border-neutral-800 rounded-2xl md:rounded-3xl p-5 md:p-12 text-center relative overflow-hidden" data-id="element-129">
          <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 bg-gradient-to-r from-amber-500 via-red-500 to-amber-500" data-id="element-130"></div>

          <ShieldCheck className="w-12 h-12 md:w-20 md:h-20 text-amber-500 mx-auto mb-3 md:mb-6" data-id="element-131" />

          <h2 className="text-xl md:text-4xl font-black text-white mb-3 md:mb-6" data-id="element-132">
            GARANTÍA RITMOS LATINOS RESUELTO — 7 DÍAS
          </h2>

          <p className="text-sm md:text-lg text-neutral-300 mb-3 md:mb-6 leading-snug" data-id="element-133">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas:
          </p>

          <p className="text-base md:text-2xl font-bold text-white mb-4 md:mb-8 bg-neutral-900 py-3 px-4 md:py-4 md:px-6 rounded-xl inline-block border border-neutral-800" data-id="element-134">
            Te devolvemos el 100%. Sin preguntas. Sin formularios. Sin drama.
          </p>

          <p className="text-neutral-400 text-xs md:text-sm max-w-xl mx-auto mb-3" data-id="element-135">
            La confianza que tenemos en RITMOS LATINOS RESUELTO nos permite
            hacer esa promesa sin dudar. Más de 500 profes de ritmos latinos de
            todo el país ya lo saben.
          </p>

          <div className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-green-500/10 text-green-400 rounded-full text-xs md:text-sm font-bold border border-green-500/20" data-id="element-136">
            La tasa de devoluciones es menor al 1%
          </div>
        </div>
      </div>
    </section>;
}